import { activeCulture, langTag } from '$lib/i18n';

let recorded = $state<string | null>(null);

function isKnown(timeZone: string): boolean {
  try {
    new Intl.DateTimeFormat(langTag(activeCulture()), { timeZone });
    return true;
  } catch {
    return false;
  }
}

export function deviceTimeZone(): string {
  return new Intl.DateTimeFormat(langTag(activeCulture())).resolvedOptions().timeZone;
}

// Unresolvable here: the device zone, not a throw on every date.
export function setRecordedTimeZone(timeZone: string | null | undefined): void {
  recorded = timeZone && isKnown(timeZone) ? timeZone : null;
}

export function displayTimeZone(): string {
  return recorded ?? deviceTimeZone();
}

export function utcOffset(timeZone: string, at: Date): string {
  const name = new Intl.DateTimeFormat(langTag(activeCulture()), { timeZone, timeZoneName: 'longOffset' })
    .formatToParts(at)
    .find((p) => p.type === 'timeZoneName')?.value;
  return name?.match(/[+-]\d{2}:\d{2}/)?.[0] ?? '+00:00';
}
